/**
 * Frontend runtime config.
 *
 * API_BASE — base URL of the backend.
 *   In dev:  defaults to http://localhost:5000
 *   In prod: GitHub Actions builds with REACT_APP_API_URL=https://astrogemapi.com
 *            (set in .github/workflows/deploy.yml)
 *
 * NOTE: CRA bakes process.env.REACT_APP_* in at build time, not runtime.
 * Changing the value requires a rebuild.
 */

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Google OAuth Client ID is PUBLIC (designed for browser embedding,
// like Stripe publishable keys). Safe to hardcode.
// Type: Web application
// Configured in Google Cloud Console with authorized origins:
//   http://localhost:3000  (dev)
//   https://astrogemapi.com (prod)
export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  '245109157044-9bv95n3roqt9f4rm6un0rtt9v5cusetc.apps.googleusercontent.com';
